import React from "react";
import "../assets/css/History.css";

import imgHistory from "../assets/img/ilustraçao-sessao4.png";

const History = () => (
  <div className="history-container">
    <div className="row">
      {/*<div className="col-12 col-md-5 d-block">*/}
      {/*  <img src={imgHistory} alt="" className="img-fluid img-history"></img>*/}
      {/*</div>*/}
      <div className="col-12 padding-sides-history d-block">
        <h1 className="title-history">Nossa História</h1>
        <p className="text-history">
          Desde 2012, a GAO TECH tem sido pioneira na transformação digital de
          pequenas e médias empresas, criando soluções tecnológicas inovadoras e
          sob medida. A cada ano, superamos desafios, aprimoramos nossos
          serviços e alcançamos marcos importantes, sempre com o objetivo de
          impulsionar o sucesso de nossos clientes. Acompanhe nossa trajetória e
          descubra como evoluímos para nos tornar referência no mercado.
        </p>
        <div className="width-history-line">
          <div className="content-line-history">
            <p className="title-line-history">2012 - Início da Jornada</p>
            <p className="text-line-history">
              Fundação da GAO TECH, com o propósito de apoiar pequenas e médias
              empresas na transformação digital.
            </p>
          </div>
          <div className="content-line-history">
            <p className="title-line-history">2013 a 2015 - Expansão</p>
            <p className="text-line-history">
              Em 2013, oficializamos a empresa sob o nome de Simples TI. Lançamos
              nosso site, profissionalizamos os serviços e passamos a focar na
              divulgação para expandir nossa base de clientes.
            </p>
          </div>
          <div className="content-line-history">
            <p className="title-line-history">
              2016 - Aprimoramento dos Serviços
            </p>
            <p className="text-line-history">
              Reformulamos nossas soluções, oferecendo serviços personalizados e
              melhorando a qualidade para atender ainda melhor as necessidades dos
              nossos clientes.
            </p>
          </div>
          <div className="content-line-history">
            <p className="title-line-history">
              2017 - Início do Atendimento a Empresas do Sistema S
            </p>
            <p className="text-line-history">
              Expandimos nosso portfólio, atendendo empresas do Sistema S e
              ampliando nosso impacto no mercado.
            </p>
          </div>
          <div className="content-line-history">
            <p className="title-line-history">
              2020 - Transformação em Fábrica de Software
            </p>
            <p className="text-line-history">
              Nos tornamos uma fábrica de software, desenvolvendo soluções sob
              medida com foco em eficiência e inovação.
            </p>
          </div>
          <div className="content-line-history">
            <p className="title-line-history">2021 - Criação do INTECAM</p>
            <p className="text-line-history">
              Lançamos o INTECAM, nosso instituto de tecnologia, com o objetivo de
              fomentar a inovação e formar talentos no setor.
            </p>
          </div>
          <div className="content-line-history">
            <p className="title-line-history">
              2024 - Criação da Startup de Tecnologia
            </p>
            <p className="text-line-history">
              Fundamos nossa própria startup de tecnologia, acelerando a inovação
              e criando novas soluções para o mercado.
            </p>
          </div>
          <div className="content-line-history">
            <p className="title-line-history">
              2025 - Certificação MPS.BR Nível C
            </p>
            <p className="text-line-history">
              Recebemos a certificação MPS.BR Nível C, reconhecendo nosso
              compromisso com a qualidade e a excelência em software.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default History;
